import styled from '@emotion/styled'
import { modalXPadding } from '@core/Areas/Quickbet/Quickbet.styles'

export const KeypadWrapperStyled = styled.ul({
  boxSizing: 'border-box',
  listStyle: 'none',
  margin: 0,
  width: '100%',
  display: 'inline-flex',
  flexWrap: 'wrap',
  padding: `0 calc(${modalXPadding} - 0.2rem)`,
})

interface KeypadItemProps {
  keysPerRow: number
}

export const KeypadItemStyled = styled.li<KeypadItemProps>(
  {
    boxSizing: 'border-box',
    padding: '0.2rem',
  },

  ({ keysPerRow }) => ({
    width: `calc(100% / ${keysPerRow})`,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: `calc(100% / ${keysPerRow})`,
  })
)
